<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-flex md6>
                      <v-autocomplete :label="labels.docNo" :items="docNoList" v-model="filters.docNo" item-text="codeValue" item-value="code" data-vv-name="docNo" :data-vv-as="labels.docNo" :error-messages="errors.collect('docNo')"></v-autocomplete>
                    </v-flex>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <div>
              <v-btn color="primary" @click.native="doNew()">
                New Document Heading Text
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.docNo }} - {{ row.item.docNoValue }}</td>
                <td>{{ row.item.docHdgNo }}</td>
                <td>{{ row.item.polType }}</td>
                <td>{{ row.item.hdgText }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Document Heading Text?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { docNoList } from './index'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Document', value: 'docNo' },
        { text: 'Heading No.', value: 'docHdgNo' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'Text', value: 'hdgText' },
        TableConst.tableActionHeader
      ],
      labels: {
        docNo: 'Document',
        docHdgNo: 'Heading No.',
        polType: 'Policy Type',
        hdgText: 'Text'
      },
      filters: {
        docNo: undefined,
        docHdgNo: undefined,
        polType: undefined,
        hdgText: undefined
      },
      totalItems: 0,
      selectedProp: undefined,
      deleteProp: undefined,
      loading: false,
      promptRemove: false,
      docNoList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInitRelatedLinks() {
      await Promise.all([this.$store.dispatch('stdRiskTxtManagementInit')])
      // await Promise.all([this.$store.dispatch('docHdgTxtManagementInit')])
    },
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getDocHdgTxtList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                let documentNo = datamap.docNo
                let docNoListText = this.docNoList
                let htxt = datamap.hdgText
                const resultTxt = docNoListText.filter((txt) => txt.code === documentNo)
                const docNoValue = resultTxt[0].value
                // Display 30 Characters only if more than 30 characters
                if (htxt != null) {
                  if (htxt.length > 30) {
                    datamap.hdgText = htxt.substr(0, 30)
                  }
                }
                const convertList = {
                  docNo: datamap.docNo,
                  docNoValue: docNoValue,
                  docHdgNo: datamap.docHdgNo,
                  polType: datamap.polType,
                  hdgText: datamap.hdgText
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.docNo = null
      this.filters.docHdgNo = null
      this.filters.polType = null
      this.filters.hdgText = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(obj) {
      let docNo = 'null'
      let docHdgNo = 'null'
      let polType = 'null'
      if (obj.docNo !== undefined) {
        docNo = obj.docNo
      }
      if (obj.docHdgNo !== undefined) {
        docHdgNo = obj.docHdgNo
      }
      if (obj.polType !== undefined) {
        polType = obj.polType
      }
      this.$router.push({ name: 'docHdgTxtReview', params: { docNo: docNo, docHdgNo: docHdgNo, polType: polType, tranMode: 'Review' } })
    },
    doNew() {
      this.$router.push({ name: 'docHdgTxtReview', params: { docNo: 'new', docHdgNo: 'new', polType: 'new', tranMode: 'New' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedProp = data
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteDocHdgTxt
      if (apiURI) {
        const expand = this.selectedProp
        if (expand.polType === undefined || expand.polType === null) {
          expand.polType = ''
        }
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doQuery(obj) {
      let docNo = 'null'
      let docHdgNo = 'null'
      let polType = 'null'
      if (obj.docNo !== undefined) {
        docNo = obj.docNo
      }
      if (obj.docHdgNo !== undefined) {
        docHdgNo = obj.docHdgNo
      }
      if (obj.polType !== undefined) {
        polType = obj.polType
      }
      this.$router.push({ name: 'docHdgTxtReview', params: { docNo: docNo, docHdgNo: docHdgNo, polType: polType, tranMode: 'Query' } })
    }
  },
  computed: {
    menu() {
      return this.$store.state.docHdgTxtParam.menu
    }
  },
  mounted() {
    this.doInitRelatedLinks()
    this.doInit(true)
  },
  components: {},
  created() {
    this.docNoList = docNoList
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
